import ApiService from '@/services/ApiService';
import { AriaCapacitor } from '@codeus/aria-capacitor';
import Store from '@/store';
import User from '@/models/User'
import * as mutationTypes from '@/store/mutationTypes';

const CardReadService = {

    shouldReadCard(order, unpaidOrders, options) {
        const isServiceSetup = !!Store.getters.tenant.venue?.settings?.integrations?.payoneos?.user_hash;
        const isAndroid = Store.getters.device.platform === 'android'
        const isCreditCardPayment = this.getCardAmount(order, unpaidOrders, options) > 0
        return isServiceSetup && isAndroid && isCreditCardPayment
    },

    async startCardRead(order, unpaidOrders, options) {
        order = order?.$duplicate() || null
        unpaidOrders = unpaidOrders.map(o => o.$duplicate())

        if(!this.shouldReadCard(order, unpaidOrders, options)) {
            return { success: false, error: 'auth' }
        }

        const resultingOrder = this.getResultingOrder(order, unpaidOrders, options)
        const cardAmount = this.getCardAmount(order, unpaidOrders, options)

        const response = await ApiService.post('/integrations/payoneos/create-payment-session', {
            order_id: resultingOrder.hash,
            amount: Money.parse(cardAmount).toFormat('0.0000'),
            type: resultingOrder.getToPay().toUnit() > 0 ? 'Sale' : 'Refund'
        })

        if(!response.data.success) {
            return {
                success: response.data.success,
                error: response.data.error
            }
        }

        const privateKey = response.data.private_key
        const softPosUrl = response.data.softpos_url
        const paymentSessionToken = response.data.payment_session_token

        Store.commit(mutationTypes.SET_PENDING_CARD_PAYMENT, {
            pendingCardPayment: {
                privateKey,
                softPosUrl,
                paymentSessionToken,
                order,
                unpaidOrders,
                options
            }
        });

        AriaCapacitor.startCardRead({ privateKey, softPosUrl, paymentSessionToken })

        return { success: true }
    },

    getCardAmount(order, unpaidOrders, options) {
        const { paymentType } = options

        if(!['credit_card', 'credit_card_business', 'advance', 'mixed_payment'].includes(paymentType)) {
            return 0
        }

        const resultingOrder = this.getResultingOrder(order, unpaidOrders, options)
        if(!resultingOrder) return 0

        if(paymentType === 'credit_card') {
            return resultingOrder.getPaidCreditCard().add(resultingOrder.getTip()).toUnit()
        }

        return resultingOrder.getPaidCreditCard().toUnit() || resultingOrder.getPaidCreditCardBusiness().toUnit()
    },

    getResultingOrder(order, unpaidOrders, options) {
        unpaidOrders = unpaidOrders.map(o => o.$duplicate())

        const userData = Store.getters.user
        const user = new User(userData)

        const { value, paymentType } = options

        let resultingOrder = order?.$duplicate() || Order.createNew(user)
        if(unpaidOrders.length) {
            resultingOrder = Order.createNew(user);
            resultingOrder.hash = unpaidOrders[0].hash.slice(5) + unpaidOrders[0].hash.slice(0, 5);
            resultingOrder.items = locale === 'me'
                ? unpaidOrders.map(o => OrderItem.createForOrder(resultingOrder, o))
                : OrderItem.merge(unpaidOrders.flatMap(o => o.items), resultingOrder);
        }

        if(resultingOrder) {
            resultingOrder.setPaid(paymentType, value)
        }

        return resultingOrder
    }
}

export default CardReadService
